/**
 * OVERRIDE EventDetails.jsx
 */

import EventDetails from '../../../../components/Events/EventDetails';

export default EventDetails;